module.exports = __webpack_public_path__ + "static/media/tu_wien.460dfd4f.jpeg";